import { render, staticRenderFns } from "./positiondetail.vue?vue&type=template&id=1bff8587&scoped=true"
import script from "./positiondetail.vue?vue&type=script&lang=js"
export * from "./positiondetail.vue?vue&type=script&lang=js"
import style0 from "./positiondetail.vue?vue&type=style&index=0&id=1bff8587&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bff8587",
  null
  
)

export default component.exports